import { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from 'utils/@reduxjs/toolkit';
import { createApi } from '@reduxjs/toolkit/query/react';
import { useInjectReducer } from 'utils/redux-injectors';
import { State } from './types';
import { endpoints, baseQuery } from 'utils/api/endpoints';

export const initialState: State = {};

const slice = createSlice({
  name: 'ordersApi',
  initialState,
  reducers: {
    someAction(state, action: PayloadAction<any>) {},
  },
});

export const api = createApi({
  reducerPath: 'ordersApi',
  baseQuery,
  endpoints: builder => ({
    getOrders: builder.query<any, any>({
      query: filters => ({
        url: endpoints.ORDERS + '/list',
        method: 'GET',
        params: filters,
      }),
    }),

    getOrdersDetails: builder.query<any, number>({
      query: orderId => ({
        url: `${endpoints.ORDERS}/${orderId}`,
        method: 'GET',
      }),
    }),
    getDigitalFiles: builder.query<any, any>({
      query: filters => ({
        url: endpoints.ORDERS + '/digital-files',
        method: 'GET',
        params: filters,
      }),
    }),
    getDownloadPackageOrders: builder.query<
      any,
      { page?: number; limit?: number; search?: string }
    >({
      query: (params = {}) => ({
        url: endpoints.DOWNLOAD_PACKAGE_ORDERS,
        method: 'GET',
        params,
      }),
    }),
    getDownloadPackageOrdersStats: builder.query<any, void>({
      query: () => ({
        url: endpoints.ORDERS + '/download-packages/stats',
        method: 'GET',
      }),
    }),
    getDigitalFilesStats: builder.query<any, void>({
      query: () => ({
        url: endpoints.ORDERS + '/digital-files/stats',
        method: 'GET',
      }),
    }),
    getCompletedOrders: builder.query<any, any>({
      query: filters => ({
        url: endpoints.ORDERS + '/completed-paid',
        method: 'GET',
        params: filters,
      }),
    }),
    getCompletedOrdersStats: builder.query<any, void>({
      query: () => ({
        url: endpoints.ORDERS + '/completed-paid/stats',
        method: 'GET',
      }),
    }),
  }),
});

export const { actions: UsersActions } = slice;

export const useOrderSlice = () => {
  useInjectReducer({ key: api.reducerPath, reducer: api.reducer });
  //  useInjectSaga({ key: slice.name, saga: Saga });
  return {
    actions: UsersActions,
    useGetOrdersQuery: api.useLazyGetOrdersQuery,
    useLazyGetOrdersDetailsQuery: api.useLazyGetOrdersDetailsQuery,
    useLazyGetDigitalFilesQuery: api.useLazyGetDigitalFilesQuery,
    useGetDownloadPackageOrdersQuery: api.useLazyGetDownloadPackageOrdersQuery,
    useGetDownloadPackageOrdersStatsQuery:
      api.useGetDownloadPackageOrdersStatsQuery,
    useLazyGetCompletedOrdersQuery: api.useLazyGetCompletedOrdersQuery,
    useGetCompletedOrdersStatsQuery: api.useGetCompletedOrdersStatsQuery,
    useGetDigitalFilesStatsQuery: api.useGetDigitalFilesStatsQuery,
  };
};
